import React from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { ProjectRole, ProjectUserInvite } from '../../types/project';
import projectService from '../../services/projectService';

interface InviteUserModalProps {
    visible: boolean;
    onCancel: () => void;
    onSuccess: () => void;
    projectId: number;
}

const InviteUserModal: React.FC<InviteUserModalProps> = ({
    visible,
    onCancel,
    onSuccess,
    projectId
}) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const handleSubmit = async (values: ProjectUserInvite) => {
        try {
            await projectService.inviteUser(projectId, values);
            onSuccess();
        } catch (error) {
            // Error handling is done in the parent component
        }
    };

    return (
        <Modal
            title={t('project.users.inviteUser')}
            open={visible}
            onCancel={onCancel}
            footer={null}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Form.Item
                    name="email"
                    label={t('project.users.email')}
                    rules={[
                        { required: true, message: t('project.users.emailRequired') },
                        { type: 'email', message: t('project.users.invalidEmail') }
                    ]}
                >
                    <Input placeholder={t('project.users.emailPlaceholder')} />
                </Form.Item>

                <Form.Item
                    name="role"
                    label={t('project.users.role')}
                    rules={[{ required: true, message: t('project.users.roleRequired') }]}
                >
                    <Select placeholder={t('project.users.rolePlaceholder')}>
                        <Select.Option value={ProjectRole.ADMIN}>{t('project.roles.admin')}</Select.Option>
                        <Select.Option value={ProjectRole.MEMBER}>{t('project.roles.member')}</Select.Option>
                        <Select.Option value={ProjectRole.VIEWER}>{t('project.roles.viewer')}</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('project.users.sendInvite')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default InviteUserModal; 